import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import CreditNoCardOnFilePurchaseRepository from "~/repository/Credit/CreditNoCardOnFilePurchaseRepository";

class CreditNoCardOnFilePurchaseStore extends NestStore {
  creditNoCardOnFilePurchaseRepository = null;

  constructor() {
    super();

    this.creditNoCardOnFilePurchaseRepository = new CreditNoCardOnFilePurchaseRepository();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.creditNoCardOnFilePurchaseRepository
      .create(data)
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}

export default CreditNoCardOnFilePurchaseStore;
